import * as React from 'react';

export const V2LayoutContext = React.createContext(false);

/**
 * Opt-in for a V2 surface that shows ONE artifact with its own header
 * (the focused Work pane): the shared tab panes skip their floating
 * `V2CanvasActionGutter` (version controller, send-to-patient, undo/redo) so
 * the surface has a single row of controls. Default `false` keeps the session
 * page's canvas exactly as it is.
 */
export const V2ActionGutterHiddenContext = React.createContext(false);
